import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AddressBook } from './models/address-book.model';

export interface AddressBookState extends EntityState<AddressBook> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'address-book', idKey: 'Id', cache: { ttl: 20000 } })
export class AddressBookStore extends EntityStore<AddressBookState> {
  constructor() {
    super();
  }

  akitaPreAddEntity(address: Readonly<AddressBook>) {
    if (!address.Id) {
      return {
        ...address,
        Id: Math.floor(Math.random() * -1000000)
      };
    }
    return address;
  }
}
